import { useMutation, useQuery } from '@apollo/client'
import clsx from 'clsx'
import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { usePlan } from '../../../context/PlanContext'
import { toast } from 'react-toastify'
import { SAVE_RAZORPAY_PAYMENT_CONFIG } from '../../../graphql/mutation'
import { GET_RAZOR_PAY_PAYMENT_CONFIG } from '../../../graphql/query'

interface IProps {
  closeRazorpayModal: () => void
}
const RazorpayModal: React.FC<IProps> = ({ closeRazorpayModal }) => {
  const { currentPlan } = usePlan()

  const { data: RazorpayData, refetch } = useQuery(GET_RAZOR_PAY_PAYMENT_CONFIG, {
    variables: {
      input: {
        bgAccountId: currentPlan?.bgAccountId
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Configuration'
      }
    }
  })

  const [addRazorPayPaymentConfig] = useMutation(SAVE_RAZORPAY_PAYMENT_CONFIG, {
    context: { headers: { 'access-control-allow-methods': 'Configuration' } }
  })

  // const { data } = useQuery(GET_ALL_EXTERNAL_SERVICES)

  console.log(currentPlan?.bgAccountId, 'currentPlan')

  // const teamsService = data?.getAllExternalServices?.find(
  //   (service: any) => service.name === 'teams'
  // )
  // const teamsServiceId = teamsService ? teamsService.id : 0

  const initialValues = {
    keyId: RazorpayData?.getRazorPayPaymentConfig?.data?.keyId || '',
    keySecret: RazorpayData?.getRazorPayPaymentConfig?.data?.keySecret || ''
  }

  console.log(RazorpayData, 'razorpayData')

  const validationSchema = Yup.object({
    keyId: Yup.string().required('Key id is required'),
    keySecret: Yup.string().required('Key secret id is required')
  })

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      addRazorPayPaymentConfig({
        variables: {
          input: {
            keyId: values.keyId,
            keySecret: values.keySecret
          }
        }
      })
        .then((res: any) => {
          closeRazorpayModal()
          if (
            res.data.addRazorPayPaymentConfig.status >= 200 &&
            res.data.addRazorPayPaymentConfig.status < 300
          ) {
            toast.success(res.data.addRazorPayPaymentConfig.message)
          } else {
            toast.error(res.data.addRazorPayPaymentConfig.message)
          }
          refetch()
        })
        .catch((err: any) => {
          closeRazorpayModal()
          toast.error('Sorry! Unexpected Error.')
          console.error(err)
        })
    }
  })
  return (
    <div className='collapse show'>
      <form className='form' onSubmit={formik.handleSubmit}>
        {formik.status && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        )}

        <div className='d-flex justify-content-between align-items-center px-3 py-2'>
          <h2 className='mb-0'>Razorpay Configuration</h2>
        </div>

        <div className='d-flex justify-content-between align-items-center px-3 py-2'>
          <p className='mb-0'>Please fill out all the required fields below.</p>
        </div>
        <div className='card-body p-9'>
          <div className='row mb-3'>
            <label className='col-form-label required fw-semibold fs-6'>Key ID</label>
            <div className='fv-row'>
              <input
                type='text'
                {...formik.getFieldProps('keyId')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid': formik.touched.keyId && formik.errors.keyId
                })}
                placeholder='Client Id'
              />
              {formik.touched.keyId && formik.errors.keyId && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{String(formik.errors.keyId)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='row mb-3'>
            <label className='col-form-label required fw-semibold fs-6'>Key Secret Id</label>
            <div className='fv-row'>
              <input
                type='text'
                {...formik.getFieldProps('keySecret')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid': formik.touched.keySecret && formik.errors.keySecret
                })}
                placeholder='Client secret Id'
              />
              {formik.touched.keySecret && formik.errors.keySecret && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{String(formik.errors.keySecret)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='d-flex justify-content-end mt-4'>
            <button type='button' className='btn btn-secondary me-4' onClick={closeRazorpayModal}>
              Cancel
            </button>
            <button type='submit' className='btn btn-sm btn-primary' disabled={formik.isSubmitting}>
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default RazorpayModal
